import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Img2 from "./images/adjust.png";
import { toast } from "react-toastify";
import api from "../api";
import useNavHighlight from "../hooks/useNavHighlight";
import usePageMeta from "../hooks/usePageMeta";

const ExportExcelFile = () => {
    const [date_before, setDate_before] = useState("");
    const [date_after, setDate_after] = useState("");
    const [status, setstatus] = useState("");
    const [filterCount, setFilterCount] = useState(0);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let count = 0;
        if (date_before) count++;
        if (date_after) count++;
        if (status) count++;
        setFilterCount(count);
    }, [date_before, date_after, status]);

    const handleGenerate = async () => {
        try {
            setLoading(true);

            const params = {};
            if (date_before) params.date_before = date_before;
            if (date_after) params.date_after = date_after;
            if (status) params.status = status;

            const response = await api.get("/api/v1/export/upc", {
                params,
                responseType: "blob",
                withCredentials: true, // ✅ THIS IS THE KEY
            });

            // Get filename
            const contentDisposition = response.headers["content-disposition"];
            let filename = "UPC_Export.xlsx";

            if (contentDisposition) {
                const match = contentDisposition.match(/filename="?([^"]+)"?/);
                if (match && match[1]) filename = match[1];
            }

            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(link.href);
            setLoading(false);
            toast.success("UPC_Export Excel Generated!");
        } catch (err) {
            setLoading(false);
            toast.error("Failed to generate Excel.");
        }
    };





    useNavHighlight("Export_Excel");
    usePageMeta("exportExcel");



    return (
        <Fragment>
            <section className="pl-[1.5vmax] pr-[2.5vmax]">
                <div className="flex justify-between items-center bg-white p-[1.2vmax] rounded-[1vmax] px-[2vmax]">
                    <h2 className="text-[1.3vmax] font-bold">Export Inventory History</h2>

                    <div className="flex-center gap-[0.8vmax] text-[1vmax]">
                        <Link to={"/my-upc-scan-slip"}>inventory</Link>
                        <div className="w-[0.3vmax] h-[0.3vmax] rounded-[50%] bg-black"></div>
                        <span className="text-slate-400">Export</span>
                    </div>
                </div>
            </section>

            <div className="pl-[1.5vmax] pr-[2.5vmax] text-right flex justify-end mt-[2vmax]">
                <button className="flex-center font-bold py-[0.6vmax] px-[1.5vmax] bg-[image:var(--gradient)] gap-[1vmax] rounded-[2vmax] text-white relative">
                    <span className="absolute top-[-0.5vmax] left-0 py-[0.1vmax] px-[0.4vmax] bg-white text-[var(--color-2)] rounded-[50%] shadow-1">
                        {filterCount}
                    </span>
                    <img src={Img2} alt="" className="w-[1.5vmax]" />
                    <span>Filters</span>
                </button>
            </div>

            <section className="pl-[1.5vmax] pr-[2.5vmax]">
                <div className="bg-white shadow-1 pb-[2vmax] px-[2vmax] rounded-[1vmax] mt-[2vmax]">
                    <div className="border-b-[0.15vmax] pt-[1.5vmax] pb-[1vmax] font-bold">
                        <h3>Filters</h3>
                    </div>

                    <div className="flex justify-between flex-wrap">

                        <div className={`flex my-[1vmax] w-full lg:w-[31.5%] border-[0.15vmax] h-fit items-center  outline-blue-400 rounded-[2vmax] ${status ? 'border-[var(--color-2)] bg-blue-50' : ''}`}>
                            <div className={`relative ${status ? 'w-[86%]' : 'w-[100%] pr-[1vmax]'}`} >
                                <select
                                    value={status}
                                    onChange={(e) => {
                                        setstatus(e.target.value)
                                    }}
                                    className='px-[2vmax] py-[0.7vmax]  w-full pr-[4vmax] outline-none rounded-[2vmax] bg-transparent'
                                >
                                    <option value="">Filter by Status</option>
                                    <option value="1">Exported</option>
                                    <option value="0">Not-Exported</option>
                                </select>
                            </div>
                            {status &&
                                <button className="w-[14%] h-fit text-[1.5vmax] text-gray-700 border-l-[0.2vmax]"
                                    onClick={() => setstatus('')}
                                >
                                    <i className="fa-solid fa-xmark"></i>
                                </button>

                            }
                        </div>
                        <div className={`flex my-[1vmax] w-full lg:w-[31.5%] border-[0.15vmax] h-fit items-center  outline-blue-400 rounded-[2vmax] ${date_after ? 'border-[var(--color-2)] bg-blue-50' : ''}`}>
                            <div className='w-[25%] bg-[image:var(--gradient)] rounded-l-[2vmax] font-bold text-white py-[0.75vmax] pl-[1vmax] ' >From :</div>
                            <div className={`relative ${date_after ? 'w-[61%]' : 'w-[80%]'}`} >
                                <input
                                    type='date'
                                    value={date_after}
                                    onChange={(e) => {
                                        setDate_after(e.target.value)
                                    }}
                                    className=' px-[2vmax] py-[0.7vmax]  w-full pr-[2vmax] outline-none rounded-[2vmax] bg-transparent'
                                />
                            </div>
                            {date_after &&
                                <button className="w-[14%] h-fit text-[1.5vmax] text-gray-700 border-l-[0.2vmax]"
                                    onClick={() => setDate_after('')}
                                >
                                    <i className="fa-solid fa-xmark"></i>
                                </button>
                            }
                        </div>

                        <div className={`flex my-[1vmax] w-full lg:w-[31.5%] border-[0.15vmax] h-fit items-center  outline-blue-400 rounded-[2vmax] ${date_before ? 'border-[var(--color-2)] bg-blue-50' : ''}`}>
                            <div className='w-[20%] bg-[image:var(--gradient)] rounded-l-[2vmax] font-bold text-white py-[0.75vmax] pl-[1vmax] ' >To :</div>
                            <div className={`relative ${date_before ? 'w-[66%]' : 'w-[75%]'}`} >
                                <input
                                    type='date'
                                    value={date_before}
                                    onChange={(e) => {
                                        setDate_before(e.target.value)
                                    }}
                                    className=' px-[2vmax] py-[0.7vmax]  w-full outline-none rounded-[2vmax] bg-transparent'
                                />
                            </div>
                            {date_before &&
                                <button className="w-[14%] h-fit text-[1.5vmax] text-gray-700 border-l-[0.2vmax]"
                                    onClick={() => setDate_before('')}
                                >
                                    <i className="fa-solid fa-xmark"></i>
                                </button>
                            }
                        </div>

                    </div>

                    {/* BUTTON */}
                    {loading ? (
                        <div className="flex-center py-[2vmax]">
                            <p>Generating Excel...</p>
                        </div>
                    ) : (
                        <div className="flex-center py-[2vmax]">
                            <button
                                onClick={handleGenerate}
                                className="bg-[image:var(--gradient-2)] px-[2vmax] py-[1vmax] rounded-[2vmax] text-white font-bold"
                            >
                                Generate Excel File
                            </button>
                        </div>
                    )}
                </div>
            </section>
        </Fragment>
    );
};

export default ExportExcelFile;
